import React, { useEffect, useState } from "react";

import { useNavigation } from "@hooks";

export const ErrorComponent: React.FC = () => {
  const { push } = useNavigation();

  return (
    <>
      <h1>Sorry, the page you visited does not exist.</h1>
      <button onClick={() => push("/")}>Back Home</button>
    </>
  );
};
